import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=295501e1"
import script from "./NavigationItem.vue?vue&type=script&lang=ts"
export * from "./NavigationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports